import { default as pages } from './pages';
import { default as global } from './global';

export const locale = {
    ...pages,
    ...global,
};
